export const getPartnerAdminFormFieldValues = partnerDetails => {
  var _partnerDetails$admin, _partnerDetails$admin2, _partnerDetails$admin3, _partnerDetails$admin4, _partnerDetails$admin5, _partnerDetails$admin6, _partnerDetails$admin7, _partnerDetails$admin8, _partnerDetails$partn, _partnerDetails$partn2;
  return {
    supportBaseUrl: (_partnerDetails$admin = (_partnerDetails$admin2 = partnerDetails.admin) === null || _partnerDetails$admin2 === void 0 ? void 0 : (_partnerDetails$admin3 = _partnerDetails$admin2.supportToolsDetails) === null || _partnerDetails$admin3 === void 0 ? void 0 : _partnerDetails$admin3.baseUri) !== null && _partnerDetails$admin !== void 0 ? _partnerDetails$admin : '',
    hasSolutionPartnerBenefit: (_partnerDetails$admin4 = (_partnerDetails$admin5 = partnerDetails.admin) === null || _partnerDetails$admin5 === void 0 ? void 0 : (_partnerDetails$admin6 = _partnerDetails$admin5.supportToolsDetails) === null || _partnerDetails$admin6 === void 0 ? void 0 : _partnerDetails$admin6.solutionPartnerBenefit) !== null && _partnerDetails$admin4 !== void 0 ? _partnerDetails$admin4 : false,
    canImportLicenses: (_partnerDetails$admin7 = (_partnerDetails$admin8 = partnerDetails.admin) === null || _partnerDetails$admin8 === void 0 ? void 0 : _partnerDetails$admin8.canImportLicenses) !== null && _partnerDetails$admin7 !== void 0 ? _partnerDetails$admin7 : false,
    marketplacePartnerTier: (_partnerDetails$partn = (_partnerDetails$partn2 = partnerDetails.partnerTier) === null || _partnerDetails$partn2 === void 0 ? void 0 : _partnerDetails$partn2.type) !== null && _partnerDetails$partn !== void 0 ? _partnerDetails$partn : ''
  };
};
export const getAdminUpdatePayload = _ref => {
  let {
    supportBaseUrl,
    canImportLicenses,
    hasSolutionPartnerBenefit,
    initialSupportBaseUrl,
    initialMarketplacePartnerTier,
    marketplacePartnerTier
  } = _ref;
  const securityPayload = [];
  let supportDetailsPayload = [];
  let marketplacePartnerTierPayload = [];
  if (initialSupportBaseUrl !== '') {
    if (supportBaseUrl) {
      supportDetailsPayload = [{
        op: 'replace',
        path: '/admin/supportToolsDetails',
        value: {
          baseUri: supportBaseUrl,
          solutionPartnerBenefit: hasSolutionPartnerBenefit
        }
      }];
    } else {
      supportDetailsPayload = [{
        op: 'remove',
        path: '/admin/supportToolsDetails'
      }];
    }
  } else if (supportBaseUrl) {
    supportDetailsPayload = [{
      op: 'add',
      path: '/admin/supportToolsDetails',
      value: {
        baseUri: supportBaseUrl,
        solutionPartnerBenefit: hasSolutionPartnerBenefit
      }
    }];
  }
  if (initialMarketplacePartnerTier !== '' && initialMarketplacePartnerTier !== (marketplacePartnerTier === null || marketplacePartnerTier === void 0 ? void 0 : marketplacePartnerTier.value) && marketplacePartnerTier !== null && marketplacePartnerTier !== void 0 && marketplacePartnerTier.value) {
    marketplacePartnerTierPayload = [{
      op: 'replace',
      path: '/partnerTier/type',
      value: marketplacePartnerTier.value
    }];
  } else if (initialMarketplacePartnerTier === '' && marketplacePartnerTier !== null && marketplacePartnerTier !== void 0 && marketplacePartnerTier.value) {
    marketplacePartnerTierPayload = [{
      op: 'add',
      path: '/partnerTier/type',
      value: marketplacePartnerTier.value
    }];
  }
  return [{
    op: 'replace',
    path: '/admin/canImportLicenses',
    value: canImportLicenses
  }, ...supportDetailsPayload, ...securityPayload, ...marketplacePartnerTierPayload];
};